import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@els/els-react--modal';
import { Loader } from '@els/els-react--loader';
import TaxonomyLookupModalFooter from './Components/TaxonomyLookupModalFooter';
import TaxonomyLookupModalHeader from './Components/TaxonomyLookupModalHeader';
import TaxonomyLookupModalContent from './Components/TaxonomyLookupModalContent';
import './TaxonomyLookupModal.scss';

const spinnerId = 'taxonomy-lookup-spinner';

function TaxonomyLookupModal(props) {
  const { close, init, isLoading, opModel } = props;
  const modalTitle = opModel?.title || 'Lookup';

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal
      onClose={close}
      shouldCloseOnEscape
      shouldPreventClickOverlayToClose
      shouldHideCloseButton
      className="react-dialogs-scrollable taxonomyLookupModal"
      id="taxonomy-lookup-modal"
      label={modalTitle}>
      <div className="taxonomyLookupModal__content">
        <TaxonomyLookupModalHeader {...props} />
        {isLoading && <Loader id={spinnerId} isVisible isBlocking={false} isSmall />}
        <TaxonomyLookupModalContent {...props} />
        <TaxonomyLookupModalFooter {...props} />
      </div>
    </Modal>
  );
}

TaxonomyLookupModal.propTypes = {
  isLoading: PropTypes.bool,
  opModel: PropTypes.object,
  init: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
};

export default TaxonomyLookupModal;
